if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.target = this.dataset.target;
      this.buttons = Array.from(this.querySelectorAll('button[data-collection]'));
      
      this.carouselWrapper = document.getElementById(this.target);

      if (!this.carouselWrapper || !this.buttons.length) return;

      this.slider = this.carouselWrapper.querySelector('.flickity-slider');
     
      if (!this.slider) return;

      // 保存所有商品节点
      this.slides = Array.from(
        this.carouselWrapper.querySelectorAll('.columns[data-collection]')
      );

      this.addEventListener('click', this.onClick.bind(this));

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const button = event.target.closest('button[data-collection]');
          if (button) this.activate(button);
        });
      }
    }

    onClick(event) {
      const button = event.target.closest('button[data-collection]');
      if (!button || !this.contains(button)) return;
    
      event.preventDefault();
      this.activate(button);
    }

    activate(button) {
      const handle = button.dataset.collection;
      if (!handle) return;

      this.buttons.forEach((btn) => {
        btn.classList.toggle('active', btn === button);
      });

      this.toggleCollection(handle);

      button.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    }

    toggleCollection(handle) {
      const fragment = document.createDocumentFragment();

      this.slides.forEach((slide) => {
        const collections = (slide.dataset.collection || '')
          .split(/[\s,|]+/)
          .filter(Boolean);

        const isActive = collections.includes(handle);

        slide.classList.toggle('carousel__slide', isActive);

        if (isActive) {
          this.slider.appendChild(slide);
        } else {
          fragment.appendChild(slide);
        }
      });

      const flkty = window.Flickity?.data(this.carouselWrapper);

      if (flkty) {
        flkty.reloadCells();
        flkty.resize();
        flkty.select(0, false, true);
      }
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}